import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import $ from 'jquery';
import 'jquery-easing';

import ConfigContext from '../../utils/ConfigContext/ConfigContext';
import FadingContainer from '../FadingContainer/FadingContainer';

const ModalLiteHeader = ({
  title,
  navBtns,
  setModalIsOpen,
}) => {
  const [titleHeight, setTitleHeight] = useState(0);

  const {
    unitHasDisplayableFees,
    displayModalPricing,
    showPricing,
  } = useContext(ConfigContext);

  // Add logging for nav buttons received
  useEffect(() => {
    // Check if sections exist on page
    if (navBtns && navBtns.length > 0) {
      navBtns.forEach(btn => {
        const sectionExists = document.getElementById(btn.section);
      });
    }

    // Log all available sections in the modal
    const allSections = document.querySelectorAll('[id]');

    // Log modal structure
    const modalEl = document.querySelector('.modal');
  }, [navBtns]);

  const handleModalNavClick = (section) => {
    const sectionDiv = document.getElementById(section);

    // we'll need this when we factor out the jquery
    // const offset = sectionDiv.getBoundingClientRect().top;
    // const modalDiv = document.getElementsByClassName('modal')[0];
    // @TODO: Refactor to remove jQuery.
    if (sectionDiv) {
      $('.modal').animate(
        {
          scrollTop:
            $(sectionDiv).offset().top - titleHeight + $('.modal').scrollTop(),
        },
        500,
        'easeInOutCubic',
      );
    }
    else {
      // If section doesn't exist, try to use the fallback div or scroll to top
      const fallbackDiv = document.getElementById('info-scroll');

      if (fallbackDiv) {
        $('.modal').animate(
          {
            scrollTop:
              $(fallbackDiv).offset().top - titleHeight + $('.modal').scrollTop(),
          },
          500,
          'easeInOutCubic',
        );
      }
      else {
        // If no fallback, just scroll to top
        $('.modal').animate(
          {
            scrollTop: 0,
          },
          500,
          'easeInOutCubic',
        );
      }
    }
  };

  const modalHeaderElement = useRef(null);

  // @TODO: Refactor into Modal component and remove jQuery.
  const modalMargin = () => {
    $('.modalContent').css('margin-top', titleHeight);
  };

  useEffect(() => {
    modalMargin(titleHeight);
  }, [titleHeight]);

  // you have to watch nav too so it will take into account the nav button height
  useEffect(() => {
    if (modalHeaderElement.current) {
      const modalHeaderHeight = modalHeaderElement.current.clientHeight;
      setTitleHeight(modalHeaderHeight);
    }
  }, [modalHeaderElement, navBtns.length]);

  // Title markup.
  let titleMarkup = '';
  // if there's only 1 property and its title.title
  if (title.length === 1 && title.title) {
    titleMarkup = <h1 className="modalTitle">{title.title}</h1>;
  }
  else {
    titleMarkup = (
      <>
        <h1 className="modalTitle">

          <span className="modalTitle__featured">
            {title?.title}
            {' '}
          </span>

          {title.fpName && title.fpName !== '' && (
            <>
              -
              {' '}
              {title.fpName}
            </>
          )}

          {title?.tags?.map((item) => (
            <span
              key={item.type}
              className={`modalTitle__tag modalTitle__tag--${item.type}`}
            >
              {item.text}
            </span>
          ))}

          {/* <span className="modalTitle--note">Reversed</span> */}
        </h1>

        {title?.bedBathSqft?.length > 0 && (

          <h2 className="modalSubtitle">
            {title.bedBathSqft.map((item, i) => (
              <span
                key={i}
                className="modalSubtitle__group"
              >
                {item}
              </span>
            ))}

            {unitHasDisplayableFees && showPricing && (
              <span className="modalSubtitle__group modalSubtitle__group__displayFees">
                <button
                  type="button"
                  className="modalSubtitle__displayFees type-display-lg"
                  onClick={() => {
                    displayModalPricing();
                  }}
                >
                  more
                </button>
              </span>
            )}

          </h2>
        )}
      </>
    );
  }

  return (
    <div className="modalHeader" ref={modalHeaderElement}>
      <div className="modalTitleArea">{titleMarkup}</div>

      {navBtns?.length > 1 && (
        <FadingContainer>
          <div className="modalNav">
            {navBtns.map((btn) => (
              <button
                type="button"
                className="modalNavItem"
                key={btn.section}
                section={btn.section}
                onClick={() => handleModalNavClick(btn.section)}
              >
                {btn.text}
              </button>
            ))}
          </div>
        </FadingContainer>
      )}

      <button
        type="button"
        className="modalClose"
        onClick={() => {
          setModalIsOpen(false);
        }}
      >
        <span>Close</span>
      </button>
    </div>
  );
};

export default ModalLiteHeader;
